import { SaleOrderService } from "@gtpl/shared-services/sale-management";
import { Card, Col, Row } from "antd"
import moment from "moment";
import React, { useEffect, useState } from "react"
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

export const PendingOrderSummaryReport = ()=>{
    const [data,setData] = useState([])
    const [data1,setData1] = useState([])
    let totalFcl =0
    const saleService = new SaleOrderService()
    useEffect(()=>{getData()},[])
    const getData =() =>{
        saleService.getPendingOrdersSummaryReportProduct().then((res)=>{
            if(res.status){
                setData(res.data)
            }else{
                setData([])
            }
        })
        saleService.getPendingOrdersSummaryReportCount().then((res)=>{
            if(res.status){
                setData1(res.data)
            }else{
                setData1([])
            }
        })
    }
    const uniqueCounts = Array.from(
        new Set(
          data1?.map(d => d.values?.map(v => v.count)).reduce((acc, val) => acc.concat(val), [])
        )
      );
      const monthCountMap = new Map();

data1.forEach(({ month, values }) => {
  const countMap = new Map();
  values.forEach(({ count, fclVal }) => {
    countMap.set(count, fclVal);
  });
  monthCountMap.set(month, countMap);
});
    // const uniqueMonths = Array.from(new Set(
    //     data1?.flatMap((item: any) =>
    //       item?.cartonsData?.map((cd: any) => cd.date)
    //     )
    //   ));
    
    //   const casesMap: { [grade: string]: { [month: string]: string } } = {};
    //   group.data?.forEach((item: any) => {
    //     casesMap[item.grade] = {};
    //     item.cartonsData?.forEach((cd: any) => {
    //       casesMap[item.grade][cd.date] = cd.cases;
    //     });
    //   });
return (
    <Card title={<span style={{color:'white'}}>Pending Order Summary Report</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<ReactHTMLTableToExcel
      id='excel-button'
      // className='download-table-xls-button'
      table='pending-order-summary-report'
      filename='PendingOrderSummaryReport'
      sheet="Sheet 1"
      buttonText='Get Excel'
      className="ant-btn ant-btn" />
      }> 
      <div style={{alignContent:'center'}} >
      <table id="pending-order-summary-report" width='100%' >
      <Row gutter={12}>
  <Col span={4}>
    <div style={{overflowY: 'auto'}} >
      <table>
        <tr style={{background:'#FBE4D6'}}>
          <th colSpan={2} className={'ta-b'} style={{textAlign:'center'}}>ORDERS ON HAND PRODUCTS SUMMARY</th>
        </tr>
        <tr>
          <th className={'ta-b'} style={{textAlign:'center'}}>PRODUCT</th>
          <th className={'ta-b'} style={{textAlign:'center'}}>FCL</th>
        </tr>
        {data?.map((e) => {
          totalFcl += e.container;
          return (
            <tr>
              <td className={'ta-b'} style={{textAlign:'center'}}>{e.product}</td>
              <td className={'ta-b'} style={{textAlign:'right'}}>{Number(e.container).toFixed(2)}</td>
            </tr>
          );
        })}
        <tr style={{ background: 'burlywood' }}>
          <td className={'ta-b'}  style={{textAlign:'center'}}>Total FCL</td>
          <td className={'ta-b'}  style={{textAlign:'right'}}>{Number(totalFcl).toFixed(2)}</td>
        </tr>
      </table>
    </div>
  </Col>
{/* </Row>

<Row gutter={12}> */}
  <Col span={6} style={{paddingLeft:'35px'}}>
    <div >
      <table style={{width:'max-content'}}>
        <tr>
          <th colSpan={data1.length + 2} className={'ta-b'} style={{textAlign:'center', background:'#90C67C'}}>ORDERS ON HAND RM COUNT SUMMARY({`${ moment(new Date()).format('DD-MM-YYYY')}`})</th>
        </tr>
        <tr>
          <th className={'ta-b'} style={{textAlign:'center'}}>HON COUNT</th>
          {data1.map((val, index) => (
            <th key={index} className={'ta-b'} style={{textAlign:'center'}}>{val.month}</th>
          ))}
          <th className={'ta-b'}> Total</th>
        </tr>

        {uniqueCounts.map((count, idx) => {
          let total = 0;
          return (
            <tr key={idx}>
              <td className="ta-b" style={{textAlign:'center'}}>{count}</td>
              {data1.map((d, index) => {
                total += Number(monthCountMap.get(d.month).get(count)?Number(monthCountMap.get(d.month).get(count)).toFixed(2) : 0);
                return (
                  <td key={index} className="ta-b" style={{textAlign:'right'}}>
                    {monthCountMap.get(d.month).get(count)?Number(monthCountMap.get(d.month).get(count)).toFixed(2): '-'}
                  </td>
                );
              })}
              <td className="ta-b" style={{textAlign:'center'}}>{Number(total).toFixed(2)}</td>
            </tr>
          );
        })}

        <tr style={{background:'#E2E0C8'}}>
          <td className="ta-b" style={{textAlign:'center'}}>Total</td>
          {data1.map((d, index) => {
            let colTotal = 0;
            uniqueCounts.forEach((count) => {
              colTotal += Number( monthCountMap.get(d.month).get(count)?Number(monthCountMap.get(d.month).get(count)).toFixed(2) : 0);
            });
            return (
              <td key={index} className="ta-b" style={{textAlign:'right'}}>
                {colTotal.toFixed(2)}
              </td>
            );
          })}
          <td className="ta-b" style={{textAlign:'right'}}>
            {data1?.reduce((grandTotal, d) => {
              let colTotal = 0;
              uniqueCounts.forEach((count) => {
                colTotal += Number( monthCountMap.get(d.month).get(count)?Number(monthCountMap.get(d.month).get(count)).toFixed(2) : 0);
              });
              return (Number(Number(grandTotal) + Number(colTotal)).toFixed(2));
            }, 0)}
          </td>
        </tr>
      </table>
    </div>
  </Col>
</Row>
    
      </table>
      </div>
      
           
    </Card>
)
}
export default PendingOrderSummaryReport